import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate, getLongDate, downloadFile, DateUtil, PaginationUtil } from 'src/app/common/util';
import { AccountResponse, MoveAccountResponse } from 'src/app/models/account.model';
import { AdvanceTransferResponse } from 'src/app/models/advance-transfer.model';
import { CashierResponse, MoveCashResponse } from 'src/app/models/cashier.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { AccountService } from 'src/app/services/account.service';
import { CashierService } from 'src/app/services/cashier.service';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { BankReportService } from 'src/app/services/reports/bank-report.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-bank-report',
  templateUrl: './bank-report.component.html',
  styleUrls: ['./bank-report.component.scss']
})
export class BankReportComponent implements OnInit {
  selectedReport = 0;
  startDate = '';
  endDate = '';
  loading = false;
  paginationAccounts = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  paginationAccountsSaving = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  paginationAdvance = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  reportsMonetaryOrSaving = [{
    name: 'Control de cuentas monetarias',
    excel: false,
    pdf: false,
    isMonetary: true
  }, {
    name: 'Control de cuentas de ahorro',
    excel: false,
    pdf: false,
    isMonetary: false
  }]
  transfer = "all";

  reportsMovesMonetaryOrSaving = [{
    name: 'Control de cuentas monetarias',
    excel: false,
    pdf: false,
    isMonetary: true
  }, {
    name: 'Control de cuentas de ahorro',
    excel: false,
    pdf: false,
    isMonetary: false
  }]

  search = {
    word: "",
    startDate: null,
    endDate: null
  }
  searchCash = {
    word: "",
    startDate: null,
    endDate: null
  }
  accountModal: AccountResponse = null;
  cashModal: CashierResponse = null;
  paginationMoves = new PaginationModel(0, 5, 0, 0, [], []);
  paginationMovesCash = new PaginationModel(0, 5, 0, 0, [], []);
  paginationCashiers = new PaginationModel(0, 5, 0, 0, [], []);
  warehouses: WarehouseResponse[] = [];
  warehouseNames: { [key: number]: string } = {};

  constructor(
    private bankReport: BankReportService,
    private toastService: ToastrService,
    private accountService: AccountService,
    private cashService: CashierService,
    private warehouseService: WarehouseService,
    private accService: AccountingReportService
  ) {
    const today = new Date();
    this.endDate = getStringDate(today);
    today.setDate(today.getDate() - 30);
    this.startDate = getStringDate(today);
  }

  ngOnInit(): void {
    this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        response.data.forEach((w) => {
          this.warehouseNames[w.id] = w.name;
        })
        this.warehouses = response.data;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las bodegas");
      }
    })
  }

  showMovesReport() {
    if (this.selectedReport == 2) {
      this.selectedReport = 0;
    } else {
      this.accountService.getAccounts().subscribe({
        next: (response: ResponseObject) => {
          var accounts = response.data;
          accounts.forEach((a) => {
            a['excel'] = false;
            a['pdf'] = false;
          })
          this.paginationAccounts.total = accounts;
          this.paginationAccounts.filter = accounts.slice(0, this.paginationAccounts.pageSize);
          this.paginationAccounts.lastElement = this.paginationAccounts.filter.length;
          this.selectedReport = 2;
        },
        error: (error: any) => {
          this.toastService.error("Error al obtener las cuentas");
        }
      })
    }
  }

  getCashiers() {
    if (this.selectedReport == 4) {
      this.selectedReport = null;
    } else {
      this.selectedReport = 4;
      this.cashService.getCashiers().subscribe({
        next: (response: ResponseObject) => {
          this.paginationCashiers.total = response.data;
          this.paginationCashiers = PaginationUtil.reset(this.paginationCashiers);
        },
        error: (error: any) => {
          this.toastService.error("Error al obtener las cuentas");
        }
      })
    }
  }

  showModalMovements(account) {
    let tempAccount = JSON.parse(JSON.stringify(account));
    var today = new Date();
    this.search.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.search.startDate = today.toLocaleDateString('en-CA');
    this.accountModal = tempAccount;
    this.getMovesReportInModal();
  }

  showModalCash(cash) {
    let tempCash = JSON.parse(JSON.stringify(cash));
    var today = new Date();
    this.searchCash.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.searchCash.startDate = today.toLocaleDateString('en-CA');
    this.cashModal = tempCash;
    this.getMovesCashInModal();
  }

  getMovesCashInModal() {
    this.accService.getMovesCash(
      this.cashModal.id,
      DateUtil.parseDateToMilliseconds(this.searchCash.startDate),
      DateUtil.parseDateToMilliseconds(this.searchCash.endDate)
    ).subscribe({
      next: (response: ResponseObject) => {
        this.cashModal.allMoves = response.data as MoveCashResponse[];
        this.filterReportCash();
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los movimientos");
      }
    });
  }

  getMovesReportInModal() {
    this.bankReport.getMovesReport(
      this.accountModal.id,
      DateUtil.parseDateToMilliseconds(this.search.startDate),
      DateUtil.parseDateToMilliseconds(this.search.endDate), 'json'
    ).subscribe({
      next: (response: ResponseObject) => {
        this.accountModal.allMoves = response.data.moves as MoveAccountResponse[];
        this.accountModal.bankName = response.data.bankName;
        this.accountModal.initialBalance = response.data.initialBalance;
        this.filterReport();
      },
      error: (error: any) => {
        this.accountModal.filteredMoves = [];
        this.accountModal.allMoves = [];
        this.toastService.error("Error al obtener los movimientos");
      }
    });
  }

  filterReportCash() {
    this.cashModal.filteredMoves = this.cashModal.allMoves.filter((a) => {
      if (this.searchCash.word) {
        var lowercase = this.searchCash.word ? this.searchCash.word.toLowerCase() : "";
        return a.document + "" == this.searchCash.word
          || a.transactionType?.toLowerCase().includes(lowercase)
          || a.employeeAlpha?.toLowerCase().includes(lowercase)
          || a.employeeEmail?.toLowerCase().includes(lowercase)
          || a.moveAmount + "" == this.searchCash.word;
      }
      return true;
    });
    this.paginationMovesCash.total = this.cashModal.filteredMoves;
    this.paginationMovesCash = PaginationUtil.reset(this.paginationMovesCash);
  }

  filterReport() {
    this.accountModal.filteredMoves = this.accountModal.allMoves.filter((a) => {
      if (this.search.word) {
        var lowercase = this.search.word ? this.search.word.toLowerCase() : "";
        return a.beneficiary?.toLowerCase().includes(lowercase)
          || a.incoming + "" == this.search.word
          || a.outcoming + "" == this.search.word
          || a.balance + "" == this.search.word
          || a.docNumber == this.search.word;
      }
      return true;
    });
    this.paginationMoves.total = this.accountModal.filteredMoves;
    this.paginationMoves = PaginationUtil.reset(this.paginationMoves);
  }

  getMonetaryOrSavingReport(type: string, report: any) {
    var loading = (status: boolean) => {
      if (type == 'excel') {
        report.excel = status;
      } else {
        report.pdf = status;
      }
    };
    loading(true);
    this.bankReport.getMonetaryOrSavingReport(getLongDate(this.endDate), type, report.isMonetary).subscribe({
      next: (response: ResponseObject) => {
        console.log(response);
        downloadFile(response.data, type, report.name + " " + this.endDate);
        this.toastService.success("Se ha descargado correctamente el reporte");
        loading(false);
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de " + report.name);
        loading(false);
      }
    })
  }

  getMovesReport(type: string, account: any) {
    var loading = (status: boolean) => {
      if (type == 'excel') {
        account.excel = status;
      } else {
        account.pdf = status;
      }
    };
    loading(true);

    this.bankReport.getMovesReport(account.id, getLongDate(this.startDate), getLongDate(this.endDate), type).subscribe({
      next: (response: ResponseObject) => {
        if (response.success) {
          downloadFile(response.data, type, 'Movimientos de cuenta ' + account.alias);
          this.toastService.success("Se descargó correctamente los movimientos de la cuenta " + account.alias);
          loading(false);
        } else {
          this.toastService.info(response.message);
          loading(false);
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.info(error.error.message);
          loading(false);
        } else {
          this.toastService.error("Error al descargar los movimientos de la cuenta " + account.alias);
          loading(false);
        }
      }
    })

  }

  getAdvanceReport(type: string) {
    this.bankReport.getAdvanceReport(this.transfer, getLongDate(this.endDate), type).subscribe({
      next: (response: ResponseObject) => {
        downloadFile(response.data, type, 'Reporte de Anticipos');
        this.toastService.success("Se ha descargado el Reporte de Anticipos");
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de Anticipos");
      }
    })
  }

  getAdvanceReportJson() {
    this.bankReport.getAdvanceReport(this.transfer, getLongDate(this.endDate), 'json').subscribe({
      next: (response: ResponseObject) => {
        var accounts = response.data;
        this.paginationAdvance.total = accounts;
        this.paginationAdvance.filter = accounts.slice(0, this.paginationAdvance.pageSize);
        this.paginationAdvance.lastElement = this.paginationAdvance.filter.length;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de Anticipos");
      }
    })
  }

  getDateFormattedString(long: number) {
    var date = new Date(long);
    return getStringDate(date);
  }
}
